import React from 'react'

export default function supplierTransactions(){
    return (
        <div>
            this is list of supplier transactions
        </div>
    )
}